import { render, staticRenderFns } from "./DIVFilter.vue?vue&type=template&id=6bd5a881&scoped=true&"
import script from "./DIVFilter.vue?vue&type=script&lang=ts&"
export * from "./DIVFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd5a881",
  null
  
)

export default component.exports